import type { User } from '../types';
import { TravellerPill } from './UserAvatar';

/**
 * "Paid by" and "Split between" as rows of avatars — the pattern the expense
 * forms use everywhere. The payer is always part of the split: choosing a
 * payer adds them, and they can't be removed while they're paying.
 */
export function PaidBySplit({ travellers, paidBy, split, onChange, payerLabel = 'Paid by' }: {
  travellers: User[];
  paidBy: string;
  split: string[];
  onChange: (patch: { paidBy?: string; split?: string[] }) => void;
  payerLabel?: string;
}) {
  return (
    <>
      <div className="space-y-1.5">
        <label className="ds-label block">{payerLabel}</label>
        <div className="flex flex-wrap gap-2 pt-1">
          {travellers.map(u => <TravellerPill key={u.id} user={u} selected={paidBy === u.id}
            onClick={() => onChange({ paidBy: u.id, split: split.includes(u.id) ? split : [...split, u.id] })} />)}
        </div>
      </div>
      <div className="space-y-1.5">
        <label className="ds-label block">Split between</label>
        <div className="flex flex-wrap gap-2 pt-1">
          {travellers.map(u => {
            const checked = split.includes(u.id);
            // The payer always stays in the split.
            return <TravellerPill key={u.id} user={u} selected={checked} locked={paidBy === u.id}
              onClick={() => onChange({ split: checked ? split.filter(id => id !== u.id) : [...split, u.id] })} />;
          })}
        </div>
      </div>
    </>
  );
}
